import { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { OfflineBanner } from './OfflineBanner.jsx';
import { AppErrorBoundary } from './ErrorBoundary.jsx';
import { MobileTopBar } from './MobileTopBar.jsx';
import { NativeBottomNav } from './NativeBottomNav.jsx';
import { NativePullToRefresh } from './NativePullToRefresh.jsx';
import { getNativeRefreshActions } from './nativeRefreshRoutes.js';

export function NativeAppShell() {
  const dispatch = useDispatch();
  const location = useLocation();
  const mainRef = useRef(null);
  const refreshActions = useMemo(
    () => getNativeRefreshActions(location.pathname),
    [location.pathname],
  );
  const refreshCurrentRoute = useCallback(() => {
    refreshActions.forEach((action) => dispatch(action));
  }, [dispatch, refreshActions]);
  const usesNativeCourseCards = ['/courses', '/assessments', '/coaching']
    .includes(location.pathname);
  const isOnboarding = location.pathname === '/onboarding';

  useLayoutEffect(() => {
    if (mainRef.current) mainRef.current.scrollTop = 0;
  }, [location.pathname, location.search]);

  return (
    <div className={`native-app-shell bg-paper text-ink${usesNativeCourseCards ? ' native-courses-shell' : ''}${isOnboarding ? ' native-onboarding-shell' : ''}`}>
      <OfflineBanner />
      {!isOnboarding && <MobileTopBar />}
      <main ref={mainRef} className={`native-main${isOnboarding ? ' native-onboarding-main' : ''}`}>
        <NativePullToRefresh
          scrollRef={mainRef}
          onRefresh={refreshCurrentRoute}
          enabled={refreshActions.length > 0}
        />
        <AppErrorBoundary>
          <Outlet />
        </AppErrorBoundary>
      </main>
      {!isOnboarding && <NativeBottomNav waitForFeatureVisibility />}
    </div>
  );
}
